import { css } from '@emotion/css'

export const CheckboxGroupDefaultClass = css``
